import { useState } from "react";
import { ReactComponent as DefaultWorkTaskIcon } from "assets/work-task.svg";

export function WorkTaskIcon({ src }: { src?: string }) {
  const [failedUrl, setFailedUrl] = useState<string>();
  if (src && src !== failedUrl) {
    return (
      <img
        src={src}
        alt=""
        aria-hidden="true"
        width={32}
        height={32}
        className="h-8 w-8 shrink-0 object-contain"
        onError={() => setFailedUrl(src)}
      />
    );
  }
  return (
    <DefaultWorkTaskIcon aria-hidden="true" className="h-8 w-8 shrink-0" />
  );
}
